<template>
  <div class="pricemonitoring-page">
    <PageProductCharts :setLowPriceType="lowpricetype" @updateData="updateLowPriceType"/>
    <PageProductTable :getLowPriceType="lowpricetype" />
  </div>
</template>

<script>
import PageProductCharts from '@/components/PriceMonitoring/PageProductCharts.vue'
import PageProductTable from '@/components/PriceMonitoring/PageProductTable.vue'
export default {
  components: {
    PageProductCharts,
    PageProductTable
  },

  data(){
    return{
      lowpricetype: ''
    }
  },

  methods: {
    updateLowPriceType: function(newData){
      this.lowpricetype = newData
    },
  }

}
</script>
